/** Render-only task feedback; excluded from the simulation fingerprint. */
export const TASK_FEEDBACK = {
  checkSeconds: 0.3,
  holdSeconds: 1.5,
  fadeSeconds: 0.5,
} as const;
